import { useTranslation } from "react-i18next";
import { PESTANAS, idPestana, idPanel, type PestanaAdmin } from "./pestanasEstado";

/**
 * Tira de pestanas del panel de administracion. Solo pinta: el estado y su
 * persistencia viven en `usePestanaAdmin` (pestanasEstado.ts).
 *
 * Roles ARIA a mano (aqui no entra ninguna libreria nueva): el `aria-selected`
 * es ademas el observable con el que los tests distinguen "una pestana activa"
 * de "tres secciones apiladas".
 */
export default function Pestanas({
  activa,
  onChange,
}: {
  activa: PestanaAdmin;
  onChange: (p: PestanaAdmin) => void;
}) {
  const { t } = useTranslation();

  return (
    <div role="tablist" className="mt-4 flex gap-1 border-b border-[var(--border)]">
      {PESTANAS.map((p) => {
        const seleccionada = p === activa;
        return (
          <button
            key={p}
            role="tab"
            id={idPestana(p)}
            aria-controls={idPanel(p)}
            aria-selected={seleccionada}
            onClick={() => onChange(p)}
            className={`-mb-px border-b-2 px-3 py-2 text-sm transition-colors ${
              seleccionada
                ? "border-[var(--foreground)] font-medium text-[var(--foreground)]"
                : "border-transparent text-[var(--muted-foreground)] hover:text-[var(--foreground)]"
            }`}
          >
            {t(`admin.tabs.${p}`)}
          </button>
        );
      })}
    </div>
  );
}
